module.exports = {
	getCategories({ commit, dispatch }, payload = null) {
		return axios.get("/api/document-center/categories", {
			params: payload
		});
	},

	getCategory({ commit }, { slug, ...payload }) {
		return axios
			.get(`/api/document-center/category/${slug}`, {
				params: payload
			})
			.then(({ data: category }) => {
				commit("setLoadedCategory", category);
				return category;
			});
	},

	updateCategory({ commit, rootGetters }, { slug, form }) {
		return axios
			.patch(`/api/document-center/category/${slug}`, form)
			.then(({ data: category }) => {
				let date = Date.now();

				commit("setLoadedCategory", category);

				commit(
					"ADD_NOTIFICATION",
					{
						show: true,
						type: "success",
						text: "Category has been updated",
						id: `category-${category.id}-updated-${date}`
					},
					{ root: true }
				);

				return category;
			});
	},

	uploadDocument({ commit }, payload) {
		return axios
			.post("/api/document-center/documents", payload, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			})
			.then(({ data }) => {
				if (data.success && data.data.length) {
					_.forEach(data.data, document => {
						commit(
							"PUSH_ITEM",
							{
								name: "document_center.documents",
								value: document
							},
							{ root: true }
						);
					});
				}

				let date = Date.now();
				commit(
					"ADD_NOTIFICATION",
					{
						show: true,
						type: "success",
						text: "Document has been uploaded",
						id: `document-${document.id}-updated-${date}`
					},
					{ root: true }
				);

				return data;
			});
	},

	getDocuments({ commit, dispatch }, payload = {}) {
		let url = "/api/document-center/documents";

		if (payload.category) {
			url += `/${payload.category}`;

			delete payload.category;
		}

		return axios.get(url, { params: payload });
	},

	getPermissionGroups({ commit, dispatch }, payload = {}) {
		let url = `/api/document-center/permissionGroups`;

		return axios.get(url, { params: payload });
	},

	getDocument({}, { id, ...payload }) {
		return axios
			.get(`/api/document-center/document/${id}`, {
				params: payload
			})
			.then(({ data: document }) => {
				return document;
			});
	},

	// deleteDocument ({ commit, dispatch }, payload) {
	// 	return axios.delete('/api/document-center/documents', { data: payload }).then(({ data }) => {
	// 		if (data.success) {
	// 			commit("deleteDocument", payload);
	// 		}
	//
	// 		return res;
	// 	})
	// },

	updateDocument({ commit, getters }, payload) {
		return axios
			.patch(`/api/document-center/documents/${payload.id}`, payload.form)
			.then(({ data }) => {
				let date = Date.now();

				const selectedDocument = getters.selectedDocument(payload.id);

				commit("updateDocumentFields", {
					document: data.data,
					selectedDocument
				});

				commit(
					"ADD_NOTIFICATION",
					{
						show: true,
						type: "success",
						text: "Document has been updated",
						id: `document-${data.data.id}-updated-${date}`
					},
					{ root: true }
				);

				return data;
			});
	},

	deleteDocument({ commit }, payload) {
		return axios
			.delete(
				`/api/document-center/documents/${payload.document_id}`,
				payload
			)
			.then(({ data }) => {
				if (data.success) {
					commit("deleteDocument", payload);
				}

				return data;
			});
	},

	removeDocumentCategory({ commit }, payload) {
		return axios
			.delete(
				`/api/document-center/documents/${payload.document_id}/categories/${payload.category_slug}`,
				payload
			)
			.then(({ data }) => {
				if (data.success && data.data) {
					commit("removeDocumentCategory", payload);
				} else {
					commit("deleteDocument", payload);
				}

				return data;
			});
	}
};
